export const environment = {
    apiBaseUrl: 'https://dev.ops-flow.co/api',
    maptilerApiKey: 'KznpyEziOv48A3vi6EY8',
};